import React from 'react';
import './styles.scss';


const Contact = props => {
  return(
    <div id='contact_page'>

    </div>
  )
}


export default Contact;
